import React from 'react'
import {Formik, Form} from 'formik'
import {useDispatch} from 'react-redux'
import {UpdateOwnersReportSetting} from '../Billing/BillingSlice/BillingSlice'
import Select from 'react-select'
import {Form as BsForm, OverlayTrigger, Tooltip, Spinner} from 'react-bootstrap'

const ReportsNotificationModule = ({reportsNotification}: any) => {
  const dispatch = useDispatch()

  // defaults from current date/time if API doesn't return data
  const now = new Date()
  const pad2 = (n: number) => String(n).padStart(2, '0')
  const defaultTime = `${pad2(now.getHours())}:${pad2(now.getMinutes())}`
  const weekDayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  const defaultWeekDay = weekDayNames[now.getDay()]
  const defaultMonthDay = now.getDate()
console.log(reportsNotification)
  const initialValues = {
    daily: {
      time: reportsNotification?.reportSettingDaily?.time ?? defaultTime,
      status: String(reportsNotification?.reportSettingDaily?.status) === 'active',
    },
    weekly: {
      weekDay: reportsNotification?.reportSettingWeekly?.weekDay ?? defaultWeekDay,
      status: String(reportsNotification?.reportSettingWeekly?.status) === 'active',
    },
    monthly: {
      monthDay: Number(reportsNotification?.reportSettingMonthly?.monthDay) ?? defaultMonthDay,
      status: String(reportsNotification?.reportSettingMonthly?.status) === 'active',
    },
  }

  const weekDays = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]

  const weekDayOptions = weekDays.map((d) => ({value: d, label: d.charAt(0).toUpperCase() + d.slice(1)}))
  const monthDays = Array.from({length: 31}, (_, i) => i + 1)
  const monthDayOptions = monthDays.map((d) => ({value: d, label: String(d)}))

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_reports_setting'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0 fs-2'>Reports Setting</h3>
        </div>
      </div>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (values, {setSubmitting}) => {
          try {
            const payload = {
              daily: { status: values.daily.status ? 'active' : 'inactive', time: values.daily.time },
              weekly: { status: values.weekly.status ? 'active' : 'inactive', weekDay: values.weekly.weekDay },
              monthly: { status: values.monthly.status ? 'active' : 'inactive', monthDay: values.monthly.monthDay },
            }
            await dispatch(UpdateOwnersReportSetting(payload))
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {({values, setFieldValue, isSubmitting}) => (
          <Form>
            <div id='kt_account_reports_setting'>
              <div className='card-body border-top p-9'>
                <div className='row align-items-center'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Daily Report</label>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>Send a daily summary at the selected time.</Tooltip>}
                    >
                      <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                    </OverlayTrigger>
                  </div>
                  <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12'>
                    <div className='d-flex align-items-center'>
                      <input
                        data-testid='inputDailyTime'
                        type='time'
                        className='form-control form-control-lg form-control-solid me-5'
                        value={values?.daily?.time}
                        onChange={(e) => setFieldValue('daily.time', e.target.value)}
                      />
                      <BsForm.Check
                        onChange={() => setFieldValue('daily.status', !values?.daily?.status)}
                        checked={!!values?.daily?.status}
                        type='switch'
                        id='daily-status'
                      />
                      <label htmlFor='daily-status' className='ms-3 mb-0'>Enable</label>
                    </div>
                    <div className='form-text'>Set time (HH:mm)</div>
                  </div>
                </div>
                <div className='row align-items-center mt-5'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Weekly Report</label>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>Send a weekly summary on the selected weekday.</Tooltip>}
                    >
                      <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                    </OverlayTrigger>
                  </div>
                  <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12'>
                    <div className='d-flex align-items-center'>
                      <div className='flex-grow-1 me-5'>
                        <Select
                          data-testid='ddWeeklyDay'
                          options={weekDayOptions}
                          value={weekDayOptions.find((o) => o.value === values?.weekly?.weekDay) || null}
                          onChange={(e: any) => setFieldValue('weekly.weekDay', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                      </div>
                      <BsForm.Check
                        onChange={() => setFieldValue('weekly.status', !values?.weekly?.status)}
                        checked={!!values?.weekly?.status}
                        type='switch'
                        id='weekly-status'
                      />
                      <label htmlFor='weekly-status' className='ms-3 mb-0'>Enable</label>
                    </div>
                  </div>
                </div>
                <div className='row align-items-center mt-5'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Monthly Report</label>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>Send a monthly summary on the selected day.</Tooltip>}
                    >
                      <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                    </OverlayTrigger>
                  </div>
                  <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12'>
                    <div className='d-flex align-items-center'>
                      <div className='flex-grow-1 me-5'>
                        <Select
                          data-testid='ddMonthlyDay'
                          options={monthDayOptions}
                          value={monthDayOptions.find((o) => o.value === values?.monthly?.monthDay) || null}
                          onChange={(e: any) => setFieldValue('monthly.monthDay', Number(e?.value))}
                          className='form-select form-select-solid form-select-lg'
                        />
                      </div>
                      <BsForm.Check
                        onChange={() => setFieldValue('monthly.status', !values?.monthly?.status)}
                        checked={!!values?.monthly?.status}
                        type='switch'
                        id='monthly-status'
                      />
                      <label htmlFor='monthly-status' className='ms-3 mb-0'>Enable</label>
                      
                    </div>
                  </div>
                </div>
              </div>

              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <button
                  type='submit'
                  className='btn btn-sm btn-primary'
                  data-testid='btnSaveChangesReportSettings'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <Spinner /> : 'Save Changes'}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default ReportsNotificationModule
